import React from 'react'
import IconHeading from '../../../components/ui/IconHeading'
import CopyToClipboard from '../../../components/function/CopyToClipboard'

const DeviceList = ({ account }) => {
  // Kiểm tra nếu account không có hoặc devices trống
  if (!account || !account.devices || account.devices.length === 0) {
    return (
      <section className="mt-8">
        <div className="flex justify-between">
          <IconHeading
            icon="ph:devices"
            title="THIẾT BỊ TRUY CẬP"
            className="ml-2 text-lg"
          />
        </div>
        <p className="mt-4 text-sm text-gray-500">
          Hiện tại chưa có thiết bị nào được thêm vào.
        </p>
      </section>
    )
  }

  // Nếu có thiết bị, render danh sách thiết bị
  return (
    <section className="mt-8">
      <div className="flex justify-between">
        <IconHeading
          icon="ph:devices"
          title="THIẾT BỊ TRUY CẬP"
          className="ml-2 text-lg"
        />
      </div>
      <div className="mt-2 grid w-full gap-4">
        <div className="flex w-full gap-8 overflow-scroll">
          {account.devices.map((device, index) => {
            const [device_os, device_id, device_type] = device.split('&')
            const lastName = account.name.split(' ').pop()
            return (
              <div key={index} className="w-fit py-2">
                <p className="flex items-center text-sm font-light text-secondarygray">
                  <span className="max-w-[20ch] truncate">{device_id}</span>
                  <CopyToClipboard value={device_id} />
                </p>
                <p className="text-sm font-bold">
                  <span>{device_type}</span> của {lastName || '--'} ({device_os}
                  )
                </p>
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}

export default DeviceList
